import React from 'react';
import { styles } from './HelpAndSupportLanding.css';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { CategoryCard } from './CategoryCard/CategoryCard';
import { Link } from '../../PlatformFunctionality';

import { HelpAndSupportSearch } from '../HelpAndSupportSearch/HelpAndSupportSearch';
import { MultiColumnBlock, MultiColumnBlockProps } from '../../MultiColumnBlock/MultiColumnBlock';
import { ContentBlock } from '../../ContentBlock';

export interface HelpAndSupportLandingProps {
  suggestedArticles: Array<{
    title: string;
    url: string;
  }>;
  categories: Array<{
    title: string;
    icon: React.ReactNode;
    url: string;
  }>;
  supportSections?: Array<MultiColumnBlockProps>;
}

export const HelpAndSupportLanding = ({
  suggestedArticles,
  categories,
  supportSections,
}: HelpAndSupportLandingProps) => {
  return (
    <>
      <div className={styles.topSection}>
        <div className={styles.header}>
          <h1>Help & Support</h1>
          <div className={styles.search}>
            <HelpAndSupportSearch />
          </div>
          {suggestedArticles.length ? (
            <div className={styles.popularSuggestions}>
              <CalloutFont>Popular:</CalloutFont>
              {suggestedArticles.map(article => (
                <Link key={article.title} href={article.url} className={styles.suggestedArticle}>
                  {article.title}
                </Link>
              ))}
            </div>
          ) : null}
        </div>
      </div>
      <div className={styles.mainSection}>
        <div className={styles.mainContent}>
          <CalloutFont as="h2">Looking for help on...</CalloutFont>
          <div className={styles.categories}>
            {categories.map(category => (
              <CategoryCard key={category.title} {...category} />
            ))}
          </div>
        </div>
      </div>
      {supportSections?.length ? (
        <div className={styles.supportSection}>
          <div className={styles.supportSectionContent}>
            {supportSections?.map((section, index) => (
              <div style={{ backgroundColor: section.theme?.background }} key={index}>
                <ContentBlock paddingLeft={0} paddingRight={0} paddingBottom={{ xs: 10, md: 15 }} maxWidth="full">
                  <MultiColumnBlock {...section} />
                </ContentBlock>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
};
